import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  ON_BOARDING_GET_GLOBAL_THEME_BEGIN,
  ON_BOARDING_GET_GLOBAL_THEME_SUCCESS,
  ON_BOARDING_GET_GLOBAL_THEME_FAILURE,
  ON_BOARDING_GET_GLOBAL_THEME_DISMISS_ERROR,
} from './constants';

export function getGlobalTheme(args = {}) {
  return (dispatch) => {
    dispatch({
      type: ON_BOARDING_GET_GLOBAL_THEME_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/on-boarding/${projectId}/global-theme`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: ON_BOARDING_GET_GLOBAL_THEME_SUCCESS,
            data: res.data.result,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: ON_BOARDING_GET_GLOBAL_THEME_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetGlobalThemeError() {
  return {
    type: ON_BOARDING_GET_GLOBAL_THEME_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ON_BOARDING_GET_GLOBAL_THEME_BEGIN:
      return {
        ...state,
        getGlobalThemePending: true,
        getGlobalThemeError: null,
      };

    case ON_BOARDING_GET_GLOBAL_THEME_SUCCESS:
      return {
        ...state,
        getGlobalThemePending: false,
        getGlobalThemeError: null,
        globalTheme: action.data,
      };

    case ON_BOARDING_GET_GLOBAL_THEME_FAILURE:
      return {
        ...state,
        getGlobalThemePending: false,
        getGlobalThemeError: action.data.error,
      };

    case ON_BOARDING_GET_GLOBAL_THEME_DISMISS_ERROR:
      return {
        ...state,
        getGlobalThemeError: null,
      };

    default:
      return state;
  }
}
